<product-list [products]="products" [isHideFilterBar]="true"[config]="config" [cateCd]="cateCd"
    [pagination]="true" [total]="total" [page]="page" [len]="len" (changePage)="onChangePage($event)">
</product-list>
